"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elog = require("@reverbdotcom/commons/dist/elog");
var bind_1 = require("../../bind");
var modal_1 = require("@reverbdotcom/commons/dist/components/modal");
var challenge_shopper_1 = require("./challenge_shopper");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var TAG = 'adyen.threeds2_challenge_shopper_modal';
var ChallengeShopperModal = /** @class */ (function (_super) {
    tslib_1.__extends(ChallengeShopperModal, _super);
    function ChallengeShopperModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: true,
        };
        return _this;
    }
    ChallengeShopperModal.prototype.onComplete = function (result) {
        var _this = this;
        this.setState({ isOpen: false }, function () { return _this.props.onComplete(result); });
    };
    ChallengeShopperModal.prototype.eventData = function (additionalContext) {
        if (additionalContext === void 0) { additionalContext = {}; }
        return {
            componentName: 'ChallengeShopperModal',
            context: tslib_1.__assign({ props: tslib_1.__assign({}, this.props) }, additionalContext),
        };
    };
    ChallengeShopperModal.prototype.componentDidMount = function () {
        tracker_1.trackView(this.eventData());
        elog.info(TAG + ".mount", tslib_1.__assign({}, this.eventData()));
    };
    // Adyen doesn't provide their own cancellation callback,
    // so if the user cancels the challenge flow (like closing the modal),
    // onComplete is triggered with a result that will cause the
    // 3DS submission process to fail gracefully.
    ChallengeShopperModal.prototype.onCancel = function () {
        this.onComplete('');
    };
    ChallengeShopperModal.prototype.render = function () {
        return (React.createElement(modal_1.default, { isOpen: this.state.isOpen, paddedBody: true, newClose: true, onRequestClose: this.onCancel },
            React.createElement(challenge_shopper_1.default, { challengeToken: this.props.challengeToken, onComplete: this.onComplete, onError: this.props.onError })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ChallengeShopperModal.prototype, "onComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ChallengeShopperModal.prototype, "onCancel", null);
    return ChallengeShopperModal;
}(React.Component));
exports.default = ChallengeShopperModal;
//# sourceMappingURL=challenge_shopper_modal.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/threeds2/challenge_shopper_modal.js
// module id = 29q+
// module chunks = 20 21 22